import React from 'react'
import { Box } from '@mui/material'
import { ClockIcon, CalendarDaysIcon, EnvelopeIcon } from '@heroicons/react/24/outline'
import { INTERAX_COLORS } from '../../../constants/colors'
import type { SprintPurposeMetrics } from './SprintPurpose.types'
import type { SprintPurposeIcon } from './SprintPurpose.types'

const metricCardStyles = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  width: '100%',
  minHeight: '82px',
  borderRadius: '10px',
  border: '1px solid rgba(255, 255, 255, 0.04)',
  boxShadow: 'inset 0px 1px 0px rgba(255, 255, 255, 0.08)',
  background:
    'radial-gradient(50.19% 50.19% at 50% 50%, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%), rgba(255, 171, 64, 0.4)',
  backgroundBlendMode: 'soft-light, normal'
} as const

interface SprintPurposeFooterProps {
  metrics: SprintPurposeMetrics
  selected: boolean
}

interface SprintPurposeMetricProps {
  label: string
  icon: SprintPurposeIcon
  selected: boolean
}

const SprintPurposeMetric: React.FC<SprintPurposeMetricProps> = ({ label, icon: Icon, selected }) => (
  <Box sx={{ ...metricCardStyles, backgroundColor: selected ? INTERAX_COLORS.sun20 : INTERAX_COLORS.heritageBlue40 }}>
    <Box sx={{ color: INTERAX_COLORS.sun, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Icon className="w-4 h-4" />
    </Box>
    <Box sx={{ color: INTERAX_COLORS.white, textAlign: 'center', fontWeight: 500, fontSize: '10px' }}>{label}</Box>
  </Box>
)

export const SprintPurposeFooter: React.FC<SprintPurposeFooterProps> = ({ metrics, selected }) => {
  const metricItems: Array<{ label: string; Icon: SprintPurposeIcon }> = [
    { label: metrics.totalTime, Icon: ClockIcon },
    { label: metrics.sprintDuration, Icon: CalendarDaysIcon },
    { label: metrics.activities, Icon: EnvelopeIcon }
  ]

  return (
    <Box sx={{ display: 'flex', gap: '12px', width: '100%' }}>
      {metricItems.map(({ label, Icon }) => (
        <SprintPurposeMetric key={label} label={label} icon={Icon} selected={selected} />
      ))}
    </Box>
  )
}

export default SprintPurposeFooter
